var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68618 25.5442V13.9894H12.6178L13.2071 9.4858H8.68751V6.61275C8.68751 5.30888 9.05414 4.42097 10.9486 4.42097L13.3657 4.4183V0.390695C12.9484 0.336034 11.5126 0.213379 9.84606 0.213379C6.35974 0.213379 3.97464 2.31184 3.97464 6.16613V9.4858H0.0336914V13.9894H3.97464V25.5442H8.68618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.04a8f72166d64e8da9db027ac26a0eaa.svg";
export { ForwardRef as ReactComponent };